import { Checkbox } from '../../controls'
import { Field } from '../field'
import type { CheckboxFieldProps } from './types'

const CheckboxField = ({
  label,
  disabled,
  error,
  align,
  onChange,
  ...rest
}: CheckboxFieldProps) => {
  return (
    <Field error={error} {...rest}>
      <Checkbox
        {...rest}
        disabled={disabled}
        error={!!error}
        label={label}
        align={align}
        onChange={onChange}
      />
    </Field>
  )
}
export default CheckboxField
